import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { Animated, StyleProp, ViewStyle } from 'react-native';

export type AnimatedCardBackgroundProps = {
  animationRef: Animated.Value;
  backgroundColor?: string;
  style?: StyleProp<ViewStyle>;
  orientation?: 'top' | 'bottom';
};

export const AnimatedCardBackground: React.FC<AnimatedCardBackgroundProps> = ({
  animationRef,
  backgroundColor,
  style,
  orientation = 'top',
}) => {
  const outputRange = orientation === 'top' ? [-500, 0] : [500, 0];

  return (
    <AnimatedBackground
      backgroundColor={backgroundColor}
      style={[
        style,
        {
          transform: [
            {
              translateY: animationRef.interpolate({
                inputRange: [0, 1],
                outputRange,
              }),
            },
          ],
        },
      ]}
    />
  );
};

export default AnimatedCardBackground;

type AnimatedBackgroundType = {
  backgroundColor?: string;
};

const AnimatedBackground = styled(Animated.View)`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 8px;
  background-color: ${({ backgroundColor }: AnimatedBackgroundType) =>
    backgroundColor};
`;
